<template>
    <div>
        <modal
        class="new-modal-default create-configure-shift-employee"
        transition="nice-modal-fade"
        :name="modal_name" 
        :delay="100" 
        height="auto"
        :width="400"
        :adaptive="true" :scrollable="true" :clickToClose="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header-new align-items-center">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title-new v-modal-title " v-if="mode == 'create'">Add Work Shift to Employee</span>
                        <span class="v-modal-dialog-title-new v-modal-title " v-if="mode == 'edit'">Edit Work Shift to Employee </span>
                    </div>
                    <div>
                        <span class="icon icon-close text-white pointer close-left" @click="hideModal"></span>
                    </div>
                </div>
                <div class="mb-3">
                    <div>
                        <span class="fs-12 text-secondary ml-5" v-if="mode == 'create'">Employee Info  </span>
                        <span class="fs-12 text-secondary ml-5" v-if="mode == 'edit'">Employee Info </span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div v-if="data_loader" class="checkoutLoader">
                        <div class="LoaderPlacement">
                                <div class="digi-table-loader">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                        </div>
                    </div>
                    <div v-else class="v-modal-layout px-4" style="border: 0.5px solid #0d84f2; border-radius: 6px;">
                        <div class="d-flex align-items-center py-2">
                            <span class=" fw-600 mr-2 fs-15" style="width: max-content;min-width: max-content; color:#130e0e">Shift Details </span>
                            <div class="inner-line-hr w-100"></div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <span class="whiteSpace fs-14 fw-500 text-black">Employee Name <span class="text-danger">*</span></span>
                                    <div class="">
                                        <multiselect
                                            class="diginew-multiselect diginew-multiselect-dropdown fs-14 mt-3"
                                            v-model="employee_name"
                                            :loading="employee_loading"
                                            :options="employee_name_options"
                                            :searchable="true"
                                            label="full_name"
                                            @search-change="searchEmployee"
                                            :close-on-select="true"
                                            v-validate="'required'"
                                            name="employee_name"
                                            :show-labels="false"
                                            @select="employeeSelected"
                                            placeholder="Select Employee"
                                            internal-search="true"
                                        >   
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfEmployeeList" />
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('employee_name')">{{errors.first('employee_name')}}</span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <div class="w-100" style="position: relative;">
                                        <label class="inputLabel fs-14 fw-500 text-black">Department</label>
                                        <input class="inputFieldNew inputFieldNew-padding" readonly name="total_working_hours" v-model="department_name" type="text" autocomplete="off" placeholder="Autofilled" />
                                        <span class="inputBorder"></span>
                                        <i class="icon icon-check fs-24 text-success ml-2" style="position: absolute;right: 10px;top: 45px;"></i>
                                    </div> 
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <span class="whiteSpace fs-14 fw-500 text-black">Shift <span class="text-danger">*</span></span>
                                    <div class="">
                                        <multiselect
                                            class="diginew-multiselect diginew-multiselect-dropdown fs-14 dd-ht mt-3"
                                            v-model="shift_name"
                                            :options="shift_name_options"
                                            :loading="shift_loading"
                                            :searchable="true"
                                            open-direction="bottom"
                                            :close-on-select="true"
                                            label="shift_name"
                                            v-validate="'required'"
                                            name="shift_name"
                                            @search-change="searchShift"
                                            @open="searchShift"
                                            :show-labels="false"
                                            placeholder="Select Shift"
                                            internal-search="true"
                                        >
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfShiftList" />
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('shift_name')">{{errors.first('shift_name')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="data_loader == false" class="v-modal-dialog-actions-new">
                    <div class="d-flex justify-content-center align-items-center">
                        <button class="btn btn-danger-new bord-rad-18px fw-500 mr-3" @click="hideModal">Cancel</button>
                        <button class="btn btn-green fw-500  ml-3" :disabled="is_api_calling" @click="saveCreateData" :class="{'text-align-left': is_api_calling}">
                            {{ is_api_calling ? 'Saving' : 'Save' }}
                            <half-circle-spinner v-if='is_api_calling' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import facility_mgmt from '../../mixins/facility_mgmt.js';
import time_utils from '../../mixins/time_utils.js';
import moment from 'moment-timezone';
import { debounce } from 'lodash';
export default {
    props: ["modal_name", "employee_shift_id", "mode"],
    components: {
        SweetModal,
        HalfCircleSpinner
    },
    mixins: [facility_mgmt, time_utils],
    data() {
        return {
            data_loader: false,
            success_msg: '',
            warning_msg: '',
            department_name: "",
            department_id: "",
            employee_name: "",
            shift_name: "",
            shift_name_options: [],
            employee_name_options: [],
            employee_loading: false,
            shift_loading: false,
            search_key: '',
            skip: 0,
            company_count: 0,
            isVisible: false,
            scrollable: false,
            shift_loading: false,
            shift_search_key: '',
            shift_count: 0,
            is_api_calling: false
        }
    },
    methods: {
        
        hideModal() {
            this.$emit('hideModal')
        },
        async searchEmployeeDebouncer(search_key) {
            this.employee_loading = true;
            this.search_key = search_key || '';
            try {
                let params = {
                    skip: this.skip,
                    limit: 10,
                    search_key: this.search_key,
                    company_id: this.loggedInUser.company_id
                };
                let response = await this.getCompanyListApi(params);
                this.employee_name_options = response.response;
                this.company_count = response.response.length;
                this.employee_loading = false;
            }
            catch (error) {
                // console.log(error);
            }
        },
        async reachedEndOfEmployeeList(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollable == false) {
                    this.employee_loading = true;
                    let params = {
                        limit: 10,
                        search_key: this.search_key,
                        company_id: this.loggedInUser.company_id,
                        skip: this.company_count
                    };
                    let response = await this.getCompanyListApi(params);
                    let temp_employee_name_options = response.response.length;;
                    if (response.skip == this.company_count) {
                        if (temp_employee_name_options > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.employee_name_options.push(el);
                            });
                            this.company_count += response.response.length;
                            this.employee_loading = false
                        } else {
                            this.scrollable = true
                            this.employee_loading = false
                        }
                    }
                    this.employee_loading = false
                }
            }
        },
        async searchShiftDebouncer(search_key) {
            this.shift_loading = true;
            this.shift_search_key = search_key || '';
            try {
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: this.shift_search_key,
                    sort_key: "shift_name",
                    sort_value: 1
                    // company_id: this.loggedInUser.company_id
                };
                let response = await this.getWorkShiftList(params);
                this.shift_name_options = response.response.workshifts;
                this.shift_count = response.response.workshifts.length;
                this.shift_loading = false;
            }
            catch (error) {
                // console.log(error);
            }
        },
        async reachedEndOfShiftList(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollable == false) {
                    this.shift_loading = true;
                    let params = {
                        limit: 10,
                        search_key: this.shift_search_key,
                        // company_id: this.loggedInUser.company_id,
                        skip: this.shift_count,
                        sort_key: "shift_name",
                        sort_value: 1
                    };
                    let response = await this.getWorkShiftList(params);
                    let temp_shift_name_options = response.response.workshifts.length;;
                    if (response.response.skip == this.shift_count) {
                        if (temp_shift_name_options > 0) {
                            let tempFiles = response.response.workshifts;
                            tempFiles.forEach(el => {
                                this.shift_name_options.push(el);
                            });
                            this.shift_count += response.response.workshifts.length;
                            this.shift_loading = false
                        } else {
                            this.scrollable = true
                            this.shift_loading = false
                        }
                    }
                    this.shift_loading = false
                }
            }
        },
        employeeSelected(data) {
            this.department_id = data.department_id;
            this.department_name = data.department_name;
        },
        async getEmpDataById(id) {
            this.data_loader = true
            try {
                let params = {
                    employee_shift_id: id
                };
                let response = await this.getEmployeeShiftById(params);
                this.employee_name = {
                    id: response.response.employee_id,
                    full_name: response.response.employee_name
                };
                this.department_id = response.response.department_id;
                this.department_name = response.response.department_name;
                this.shift_name = {
                    _id: response.response.workshift_id,
                    shift_name: response.response.work_shift
                };
                this.data_loader = false
            }
            catch (error) {
                this.data_loader = false
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        },
        saveCreateData() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.saveSuccess();
                } else {
                    this.warning_msg = "Please fill all the required fields";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            });
        },
        async saveSuccess() {
            this.is_api_calling = true;
            try {
                let response;
                if(this.mode == 'create') {
                    response = await this.createEmployeeShift(this.create_data);
                } else {
                    this.create_data.employee_shift_id = this.employee_shift_id;
                    response = await this.editEmployeeShift(this.create_data);
                }
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('hideModal')
                    this.$emit('saveSuccess')
                }, 3000);
            }
            catch (error) {
                this.is_api_calling = false;
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        }
    },
    mounted() {
        if(this.mode == 'edit') {
            this.getEmpDataById(this.employee_shift_id);
        }
    },
    watch: {
        
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        create_data() {
            return {
                department_id: this.department_id,
                department_name: this.department_name,
                employee_id: this.employee_name.id,
                employee_name: this.employee_name.full_name,
                shift_name: this.shift_name._id
            };
        },
    },
    created() {
        this.searchEmployee = debounce(this.searchEmployeeDebouncer, 500)
        this.searchShift = debounce(this.searchShiftDebouncer, 500)
        const dict = {
            custom: {
                shift_name:{
                    required:() => "Shift Name is required"
                },
                employee_name:{
                    required:() => "Employee is required"
                },
            }
        }
        this.$validator.localize('en', dict)
    }
}
</script>
<style scoped>
.border{
    border:0.5px solid #0d84f2 !important;
}
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 2px solid #a5a5a5;
}
.v-modal-dialog-actions-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 0px solid transparent;
}

.v-modal-header-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    padding-left: 15px;
    padding-top: 15px;
    border-bottom: 0px solid #E9ECEF;
    -webkit-border-top-left-radius: 15px;
    border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    border-top-right-radius: 15px;
    background-color: white !important;
}
.v-modal-dialog-title-new{
    margin-bottom: 0px !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    padding: 4px !important;
}
    .form-group, .form-check {
        will-change: unset !important;
    }
    .text-align-left{
        text-align: left !important;
    }
    .v-modal-content{
        border-radius: 15px !important;
    }
    .checkoutLoader{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>